import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
    bodyText: {
        color: theme?.palette?.text?.secondary
    }
}));
